// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__HAeMr","tab":"Tabs_tab__um5pp"};